;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ["stepupURL", "token", "md", "origin"],
    mounted: function mounted() {
        this.submitForm();
        window.addEventListener("message", this.handleMessage, false);
    },

    methods: {
        submitForm: function submitForm() {
            this.$refs.stepupForm.submit();
        },

        handleMessage: function handleMessage(event) {
            if (event.origin === this.origin) {
                this.$emit("stepupChecked", event.data);
            }
        }
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener("message", this.handleMessage, false);
    }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{attrs:{"name":"step-up-iframe","width":"600","height":"400"}}),_vm._v(" "),_c('form',{ref:"stepupForm",attrs:{"target":"step-up-iframe","method":"POST","action":_vm.stepupURL}},[_c('input',{attrs:{"type":"hidden","name":"JWT"},domProps:{"value":_vm.token}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"MD"},domProps:{"value":_vm.md}})])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-71486f09", __vue__options__)
  } else {
    hotAPI.reload("data-v-71486f09", __vue__options__)
  }
})()}